/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-605e961c.js';
import { _ as _typeof } from '../_chunks/dep-2055661d.js';
import { useCallback, useState, useEffect } from 'react';
import { d as debounce_1 } from '../_chunks/dep-ac257584.js';
import '../_chunks/dep-f66447d3.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-37e82645.js';
import '../_chunks/dep-a0293295.js';
import '../_chunks/dep-dae4a585.js';

function useWindowSize() {
  var validWindow = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object";
  var getSize = useCallback(function () {
    return {
      width: validWindow ? window.innerWidth : void 0,
      height: validWindow ? window.innerHeight : void 0
    };
  }, [validWindow]);
  var _useState = useState(getSize()),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  useEffect(function () {
    function handleResize() {
      setSize(getSize());
    }
    var debounceResize = debounce_1(handleResize, 400);
    if (validWindow) {
      window.addEventListener("resize", debounceResize);
      return function () {
        window.removeEventListener("resize", debounceResize);
        debounceResize.cancel();
      };
    }
  }, [getSize, validWindow]);
  return size;
}

export { useWindowSize as default };
//# sourceMappingURL=useWindowSize.js.map
